<script>
  export let isOpen = false;   // Modal visibility
  export let closeModal = () => {}; // Function to close modal

  function handleClickOutside(event) {
    if (event.target === event.currentTarget) {
      closeModal();
    }
  }

  // Handle form submit -> POST to backend
  async function handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(event.target);
    const payload = Object.fromEntries(formData);

    try {
      const res = await fetch('/api/appointment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await res.json();

      if (result.success) {
        alert('Appointment request sent successfully!');
        closeModal();
      } else {
        alert(' Failed: ' + (result.error || 'Unknown error'));
      }
    } catch (err) {
      console.error('Submit error:', err);
      alert(' Error sending appointment request.');
    }
  }
</script>

{#if isOpen}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="fixed inset-0 z-40 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4"
    on:click={handleClickOutside}
  >
    <div
      class="relative bg-white/20 backdrop-blur-2xl border border-white/30 p-6 sm:p-8 rounded-3xl shadow-2xl w-full max-w-lg sm:max-w-xl md:max-w-2xl lg:max-w-3xl animate-fadeIn 
             max-h-[90vh] overflow-y-auto"
    >
      <!-- Close Button -->
      <button
        on:click={closeModal}
        aria-label="Close modal"
        class="absolute top-3 right-4 text-gray-200 text-3xl hover:text-white transition"
      >
        &times;
      </button>

      <!-- Heading -->
      <h2
        class="text-2xl sm:text-3xl font-bold text-center mb-6 text-white drop-shadow-lg">
        Schedule Your Appointment
      </h2>

      <!-- FORM -->
      <form on:submit|preventDefault={handleSubmit} class="space-y-6">
        
        <!-- First + Last Name -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label for="firstName" class="block text-base sm:text-lg font-medium text-white/90">First Name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              class="w-full p-3 mt-2 rounded-xl bg-white/20 backdrop-blur-md border border-white/40 
                     text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-cyan-300"
              placeholder="Enter first name"
              required
            />
          </div>

          <div>
            <label for="lastName" class="block text-base sm:text-lg font-medium text-white/90">Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              class="w-full p-3 mt-2 rounded-xl bg-white/20 backdrop-blur-md border border-white/40 
                     text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-cyan-300"
              placeholder="Enter last name"
              required
            />
          </div>
        </div>

        <!-- Phone + Email -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label for="phone" class="block text-base sm:text-lg font-medium text-white/90">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              class="w-full p-3 mt-2 rounded-xl bg-white/20 backdrop-blur-md border border-white/40 
                     text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-cyan-300"
              placeholder="Enter phone number"
              required
            />
          </div>

          <div>
            <label for="email" class="block text-base sm:text-lg font-medium text-white/90">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              class="w-full p-3 mt-2 rounded-xl bg-white/20 backdrop-blur-md border border-white/40 
                     text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-cyan-300"
              placeholder="Enter email address"
              required
            />
          </div>
        </div>

        <!-- Purpose -->
        <div>
          <label for="purpose" class="block text-base sm:text-lg font-medium text-white/90">Purpose of Visit</label>
          <select
            id="purpose"
            name="purpose"
            class="w-full p-3 mt-2 rounded-xl bg-white/20 backdrop-blur-md border border-white/40 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-cyan-300"
            required
          >
            <option value="" disabled selected class="bg-gray-800">Select Purpose</option>
            <option value="consultation" class="bg-gray-800">Consultation</option>
            <option value="follow_up" class="bg-gray-800">Follow-up</option>
            <option value="emergency" class="bg-gray-800">Emergency</option>
            <option value="checkup" class="bg-gray-800">General Check-up</option>
          </select>
        </div>

        <!-- Date + Time -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label for="date" class="block text-base sm:text-lg font-medium text-white/90">Select Date</label>
            <input
              type="date"
              id="date"
              name="date"
              class="w-full p-3 mt-2 rounded-xl bg-white/20 backdrop-blur-md border border-white/40 
                     text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-cyan-300"
              required
            />
          </div>

          <div>
            <label for="time" class="block text-base sm:text-lg font-medium text-white/90">Select Time</label>
            <select
              id="time"
              name="time"
              class="w-full p-3 mt-2 rounded-xl bg-white/20 backdrop-blur-md border border-white/40 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-cyan-300"
              required
            >
              <option value="" disabled selected class="bg-gray-800">Select Time</option>
              <option value="09:00" class="bg-gray-800">09:00 AM</option>
              <option value="10:00" class="bg-gray-800">10:00 AM</option>
              <option value="11:00" class="bg-gray-800">11:00 AM</option>
              <option value="12:00" class="bg-gray-800">12:00 PM</option>
              <option value="01:00" class="bg-gray-800">01:00 PM</option>
              <option value="02:00" class="bg-gray-800">02:00 PM</option>
              <option value="03:00" class="bg-gray-800">03:00 PM</option>
              <option value="04:00" class="bg-gray-800">04:00 PM</option>
            </select>
          </div>
        </div>

        <!-- Notes -->
        <div>
          <label for="message" class="block text-base sm:text-lg font-medium text-white/90">Additional Notes</label>
          <textarea
            id="message"
            name="message"
            rows="4"
            class="w-full p-3 mt-2 rounded-xl bg-white/20 backdrop-blur-md border border-white/40 
                   text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-cyan-300"
            placeholder="Write any extra details..."
          ></textarea>
        </div>

        <!-- Submit -->
        <div class="pt-4">
          <button
            type="submit"
            class="w-full py-3 bg-gradient-to-r from-cyan-400 via-green-300 to-yellow-300 
                   text-gray-900 font-semibold text-lg rounded-full shadow-lg 
                   hover:opacity-90 transition-all duration-300"
          >
            Schedule Appointment
          </button>
        </div>
      </form>
    </div>
  </div>
{/if}

<style>
  @keyframes fadeIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-out;
  }
  input[type="date"]::-webkit-calendar-picker-indicator,
  input[type="time"]::-webkit-calendar-picker-indicator {
    filter: invert(1) brightness(1.5);
    cursor: pointer;
  }
  select {
    background-image: none !important;
  }
</style>
